import { useEffect } from "react";
import { useQueryParam } from "use-query-params";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useOverlays } from "contexts/OverlayContext";
import {
    ENROLL_ACTION_QUERY_PARAM,
    EnrollAction,
} from "../organizationBilling/lib";

export function useHandleEnrollAction() {
    const navigate = useStateAwareNavigate();
    const { openOverlay } = useOverlays();
    const [action] = useQueryParam(ENROLL_ACTION_QUERY_PARAM);

    useEffect(() => {
        if (action === EnrollAction.CREATE_CLIENT) {
            openOverlay("addClient", true);
            navigate(".", { replace: true });
        }
    }, [action, openOverlay, navigate]);
}
